import type { ProductRelationKind, RelatedProduct } from '../api/business/types';

/** The kinds in the order the product page shows them (R0030 WP-08) — the API's list. */
export const RELATION_KINDS: Array<ProductRelationKind> = ['ACCESSORY', 'UP_SELL', 'CROSS_SELL'];

/** The ids of a list of related products, in its order — what a change sends back. */
export const relatedIdsOf = (related: Array<RelatedProduct>): Array<string> => related.map((one) => one.id);

/** `ids` with the one at `index` moved by `step` (−1 up, 1 down); unchanged at either end. */
export const movedInList = (ids: Array<string>, index: number, step: -1 | 1): Array<string> => {
  const target = index + step;

  if (index < 0 || index >= ids.length || target < 0 || target >= ids.length) {
    return ids;
  }

  const moved = [...ids];

  [moved[index], moved[target]] = [moved[target], moved[index]];

  return moved;
};

/** `ids` without `id`. */
export const withoutInList = (ids: Array<string>, id: string): Array<string> =>
  ids.filter((one) => one !== id);
